import api from "../../api"
import { ItemCategoriesState, ItemCategory } from "./itemCategoriesModel"

export const itemCategoriesEndpoint = `/web/item-categories`

export const getItemCategories = async (): Promise<ItemCategory[]> => {
  return (await api.get<ItemCategory[]>(itemCategoriesEndpoint)).data
}

export const saveItemCategories = async (changeSet: ItemCategoriesState) => {
  return (await api.post(itemCategoriesEndpoint, {...changeSet})).data
}